// Plain CSS for the printable documents. Rendered as a <style> element inside
// the document itself so it travels with the content into the print iframe
// (react-to-print) and works on the public (shell-less) pages. Colours and the
// font stack come from the brand tokens (vendia/brand/ui.ts).

import { vendiaTokens } from '../../brand';
import { UI } from '../../brand/ui';

const FONT = vendiaTokens.typography.fontFamily.primary.map((f) => (f.includes(' ') ? `'${f}'` : f)).join(', ');

export const documentCss = `
.vd-doc { font-family: ${FONT}; color: ${UI.ink}; font-size: 13px; line-height: 1.45; background: ${UI.white}; }
.vd-doc * { box-sizing: border-box; }
.vd-doc .vd-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; padding-bottom: 12px; }
.vd-doc .vd-brand { display: flex; gap: 12px; align-items: flex-start; }
.vd-doc .vd-logo { max-height: 64px; max-width: 160px; object-fit: contain; }
.vd-doc .vd-brand ul { list-style: none; margin: 0; padding: 0; }
.vd-doc .vd-ref-badge { font-family: 'Courier New', monospace; font-size: 15px; letter-spacing: 2px; border: 1px solid ${UI.borderStrong}; padding: 6px 10px; border-radius: 4px; white-space: nowrap; }
.vd-doc .vd-heading { text-align: center; text-transform: uppercase; font-size: 16px; font-weight: 700; padding: 8px 0; border-top: 1px solid ${UI.border}; border-bottom: 1px solid ${UI.border}; margin: 0; }
.vd-doc .vd-row { display: flex; flex-wrap: wrap; gap: 8px 16px; padding: 8px 0; border-bottom: 1px solid ${UI.border}; }
.vd-doc .vd-row > div { flex: 1 1 220px; }
.vd-doc .vd-parties { display: flex; flex-wrap: wrap; gap: 16px; margin-top: 14px; }
.vd-doc .vd-parties > div { flex: 1 1 220px; }
.vd-doc .vd-muted { color: ${UI.textSecondary}; }
.vd-doc .vd-alert { margin-top: 12px; padding: 8px 12px; border-radius: 6px; font-weight: 600; }
.vd-doc .vd-alert.error { background: ${UI.dangerTint}; color: ${UI.danger}; border: 1px solid ${UI.dangerLine}; }
.vd-doc .vd-alert.warning { background: ${UI.warningTint}; color: ${UI.warning}; border: 1px solid ${UI.warningLine}; }
.vd-doc table.vd-table { width: 100%; border-collapse: collapse; margin-top: 14px; }
.vd-doc table.vd-table th, .vd-doc table.vd-table td { padding: 6px 8px; border: 1px solid ${UI.border}; vertical-align: top; }
.vd-doc table.vd-table thead th { background: ${UI.headerFill}; font-weight: 700; }
.vd-doc table.vd-table tfoot th, .vd-doc table.vd-table tfoot td { background: ${UI.surface}; }
.vd-doc .vd-right { text-align: right; }
.vd-doc .vd-center { text-align: center; }
.vd-doc .vd-left { text-align: left; }
.vd-doc .vd-bold { font-weight: 700; }
.vd-doc .vd-sub td { border-top: none; border-bottom: none; padding-top: 2px; padding-bottom: 2px; color: ${UI.textSecondary}; }
.vd-doc .vd-sub td:first-child { padding-left: 20px; }
.vd-doc .vd-box { margin-top: 14px; padding: 10px 12px; border: 1px solid ${UI.border}; border-radius: 6px; white-space: pre-line; }
.vd-doc .vd-cgd { margin-top: 16px; text-align: center; font-size: 11px; color: ${UI.textSecondary}; }
.vd-doc .vd-attachments { margin-top: 14px; }
.vd-doc .vd-attachments a { color: ${UI.accent}; margin-right: 12px; }
.vd-doc.vd-receipt { width: 300px; max-width: 100%; margin: 0 auto; font-size: 12px; }
.vd-doc.vd-receipt .vd-center-block { text-align: center; margin-bottom: 10px; }
.vd-doc.vd-receipt .vd-logo { max-height: 56px; max-width: 200px; }
.vd-doc.vd-receipt table { width: 100%; border-collapse: collapse; margin: 10px 0; }
.vd-doc.vd-receipt th, .vd-doc.vd-receipt td { padding: 3px 2px; border-bottom: 1px dashed ${UI.borderStrong}; vertical-align: top; }
.vd-doc.vd-receipt .vd-sub td { border-bottom: none; }
.vd-doc.vd-receipt h3 { margin: 6px 0; text-align: center; font-size: 14px; }
@media print {
  .vd-no-print { display: none !important; }
  .vd-doc { font-size: 12px; }
}
`;

export const invoicePageStyle = '@page { size: auto; margin: 12mm; } body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }';
export const receiptPageStyle = '@page { size: 80mm auto; margin: 3mm; } body { margin: 0; }';
